import React from 'react';
import { Helmet } from 'react-helmet';

const OtpPage = () => {
  return (
    <div style={containerStyle}>
      <Helmet>
        <title>OTP Verification via SMS | SMS Textr</title>
        <meta name="description" content="SMS Textr provides secure OTP verification services via SMS for users in the USA and Canada. Handle both OTP sending and verifying with ease." />
        <meta name="keywords" content="OTP API, SMS verification, send OTP, verify OTP, secure login, SMS Textr OTP service, USA Canada OTP API" />
      </Helmet>

      <section style={headerStyle}>
        <h1 style={{ fontSize: '2rem', color: '#2c3e50' }}>🔐 One-Time Password (OTP) Service</h1>
        <p style={{ fontSize: '1.1rem', marginTop: '10px', color: '#555' }}>
          <strong>SMS Textr</strong> offers a secure and reliable One Time Password (OTP) verification service via SMS, available exclusively for users in the <strong>USA and Canada</strong>. Our API allows your application to handle both stages—<strong>sending</strong> the OTP and <strong>verifying</strong> it. <strong>1 credit</strong> is deducted per OTP sent to a phone number. OTP Verification is done without any credit deductions.
        </p>
      </section>

      <section style={cardStyle}>
        <h2 style={sectionHeader}>📤 Send OTP</h2>
        <p>You can initiate the OTP process by making a POST request to:</p>
        <code style={codeStyle}>https://smstextr.web.app/api/sendotp</code>

        <p><strong>Required payload:</strong></p>
        <pre style={preStyle}>{`{
  "to": "+1-123-456-7890",
  "apikey": "Your_API_Key"
}`}</pre>

        <p><strong>Optional parameters:</strong></p>
        <pre style={preStyle}>{`{
  "to": "+1-123-456-7890",
  "org": "SMS Textr",
  "limit": "7",
  "apikey": "Your_API_Key"
}`}</pre>

        <ul>
          <li><code>limit</code>: Number of minutes before OTP expires (between 2 and 10, default is 5)</li>
          <li><code>org</code>: Organization name to personalize the SMS message</li>
        </ul>

        <p><strong>Message received by the user:</strong></p>
        <pre style={preStyle}>{`Your one-time verification code is 123456.`}</pre>
        <pre style={preStyle}>{`Message from [SMS Textr]. Your one-time verification code is 123456.`}</pre>

        <p style={{ fontStyle: 'italic', color: '#999' }}>* Future updates will allow custom message templates as well as different digits of OTP ranging from 4 digits to 8 digits.</p>
      </section>

      <section style={cardStyle}>
        <h2 style={sectionHeader}>✅ Verify OTP</h2>
        <p>To verify the OTP submitted by your user, send a POST request to:</p>
        <code style={codeStyle}>https://smstextr.web.app/api/verifyotp</code>

        <p><strong>Required payload:</strong></p>
        <pre style={preStyle}>{`{
  "otp": "123456",
  "apikey": "Your_API_Key"
}`}</pre>

        <p><strong>Response:</strong></p>
        <ul>
          <li><code>"OTP verified"</code> – Success ✅</li>
          <li><code>"OTP not found"</code> – Invalid or incorrect</li>
          <li><code>"OTP expired"</code> – Time limit exceeded</li>
          <li><code>"OTP already used"</code> – Previously verified</li>
        </ul>
      </section>

      <section style={cardStyle}>
  <h2 style={sectionHeader}>Example of Node JS Code for Sending OTP</h2>
  
  <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
    <code>
      {`const axios = require('axios');

// Sending OTP example
const sendOtp = async () => {
  const payload = {
    to: "+1 123-456-7890",
    org: "YourCompany", // Optional
    limit: 5, // Optional
    apikey: "Your_API_Key"
  };

  try {
    const response = await axios.post('https://smstextr.web.app/api/sendotp', payload);
    console.log('OTP sent successfully:', response.data);
  } catch (error) {
    console.error('Error sending OTP:', error.response ? error.response.data : error.message);
  }
};
`}
    </code>
  </pre>
</section>

 <section style={cardStyle}>
  
  <h2 style={sectionHeader}>Example of Node JS Code for Verifying OTP</h2>

  <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
    <code>

{`const axios = require('axios');
// Verifying OTP example
const verifyOtp = async () => {
  const payload = {
    otp: 123456,
    apikey: "Your_API_Key"
  };

  try {
    const response = await axios.post('https://smstextr.web.app/api/verifyotp', payload);
    console.log('OTP verified successfully:', response.data);
  } catch (error) {
    console.error('Error verifying OTP:', error.response ? error.response.data : error.message);
  }
};


`}
    </code>
  </pre>
</section>

    </div>
  );
};

const containerStyle = {
  padding: '20px',
  fontFamily: 'Segoe UI, sans-serif',
  backgroundColor: '#f5f7fa',
};

const headerStyle = {
  marginBottom: '30px',
  backgroundColor: '#e6f9ec',
  padding: '20px',
  borderRadius: '10px',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
};

const cardStyle = {
  backgroundColor: '#ffffff',
  padding: '25px',
  marginBottom: '30px',
  borderRadius: '10px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
};

const sectionHeader = {
  fontSize: '1.5rem',
  color: '#4CAF50',
  marginBottom: '10px',
};

const codeStyle = {
  display: 'block',
  backgroundColor: '#f1f1f1',
  padding: '8px 12px',
  borderRadius: '5px',
  fontFamily: 'Courier New, monospace',
  marginBottom: '10px',
};

const preStyle = {
  backgroundColor: '#f4f4f4',
  padding: '10px 15px',
  borderRadius: '6px',
  fontFamily: 'Courier New, monospace',
  overflowX: 'auto',
  color: '#333',
};

export default OtpPage;
